import { useEffect, useState } from "react";

const INITIAL_GRID_STATE = {
  gridData: []
};

const useSelectionsAdminToolGrid = (data, onSubmitFormCallback) => {
  const [gridState, setGridState] = useState(INITIAL_GRID_STATE);

  const onAddSelectedClicked = (event, selectedIds) => {
    try {
      event?.preventDefault();

      const champObjects = selectedIds.map((id) => {
        return {
          ncaaConferenceChampionsId: id
        };
      });

      const champions = [];
      champions.push(...champObjects);

      onSubmitFormCallback(champions);
    } catch (e) {
      // onNTGroupsError(e);
      console.error('Error in onAddSelectedClicked:', e);
    }
  };
  
  useEffect(() => {
    if (Array.isArray(data)) {
      setGridState({
        ...gridState,
        gridData: data
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps   
  }, [data]);

  return {
    gridState,
    onAddSelectedClicked
  };
};

export default useSelectionsAdminToolGrid;